export class AjaxController {

    constructor(url, $div, options) {
        this.url = url;
        this.$div = $div || null;

        // Options
        options = options || {};
        this.method = options.method || "POST";
        this.isProd = options.isProd || APP.isProdEnv;
        this.preventScrollTo = options.preventScrollTo || false;
        this.topOffset = options.topOffset || 0;
        this.actions = options.actions || {};
        this.sucessCallback = options.success || null;
    }


    submit(data) {
        let that = this;
        let options = {
            url: this.url,
            type: this.method,
            data: data,
            success: function (data) {
                if (!data) {
                    that.alert("Die Antwort des Servers war fehlerhaft (leer)");
                } else {
                    that.requestSuccess(JSON.parse(data));
                }
            },
            error: function (data) {
                if (that.isProd) {
                    that.alert("Ein unbekannter Fehler ist aufgetreten");
                } else {
                    data = JSON.parse(data);
                    that.alert("Request Fehler! Status-Code " + data.status + " " + data.statusText);
                }
            },
        };

        if (data instanceof FormData) {
            options.contentType = false;
            options.processData = false;
        }

        return $.ajax(options);
    }


    requestSuccess(data) {
        if (!data || typeof data !== 'object') {
            return;
        }
        if (data.actions) {
            for (var i in data.actions) {
                var act = data.actions[i];
                this.runAction(act.name, act.params);
            }
        }
        if (this.sucessCallback) {
            this.sucessCallback(data);
        }
    }


    runAction(action, params) {
        if (action == "alert") {
            this.alert(params.msg, params.type);
        } else if (action == "goto") {
            document.location.href = params.href;
        } else if (action == "replaceDiv") {
            let $cont;
            if (params.sel) {
                $cont = params.onParentDivOnly ? this.$div.find(params.sel) : $(params.sel);
            } else {
                $cont = this.$div;
            }
            $cont.each(function () {
                const $ele = $(this);
                params.keepContainer ? $ele.html(params.content) : $ele.replaceWith(params.content);
                APP.onLoadObj.run($ele);
            });
        } else if (action == "runCode" && typeof APP[params.name] === "function") {
            APP[params.name](...params.args);
        } else if (action == "runUserCode" && typeof APP.user[params.name] === "function") {
            APP.user[params.name](...params.args);
        } else if (typeof this.actions[action] === "function") {
            if (params && params.args) {
                this.actions[action](...params.args);
            } else {
                this.actions[action]();
            }
        } else {
            this.alert("Aktion " + action + " unbekannt");
        }
    }


    alert(msg, type) {
        msg = typeof msg === "array" ? msg.join("<br>") : msg;

        if (this.$div && this.$div.length > 0) {
            let $cont = this.$div.find(".alert-container");
            if (!$cont || $cont.length === 0) {
                $cont = $("<div class='alert-container'></div>");
                this.$div.prepend($cont);
            }

            $cont.html('<div class="alert alert-' + (type || "error") + '">' + msg + '</div>');
            this.scrollTo($cont);
            $cont.fadeIn(500);
        } else {
            APP.notify(msg, type);
        }

        if (!this.isProd) {
            console.log(msg);
        }
    }


    scrollTo($ele) {
        if (this.preventScrollTo || !$ele.length) {
            return;
        } else if ($("body").hasClass("modal-opened")) {
            $(".modal-body").animate({
                scrollTop: $ele.offset().top - this.topOffset
            }, 600);
        } else {
            $([document.documentElement, document.body]).animate({
                scrollTop: $ele.offset().top - this.topOffset
            }, 600);
        }
    }
}
